import type { IErrorInfo } from '../errors';
import { errorInfoSchema } from '../errors';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const ERROR = 'VISION/ERROR';

export interface IErrorAction {
  type: typeof ERROR;
  payload: IErrorInfo;
}

export const errorActionSchema = objectSchemaOf<IErrorAction>({
  type: Joi.string().required().valid(ERROR),
  payload: errorInfoSchema.required(),
});

export const error = actionCreator({
  type: ERROR,
  schema: errorActionSchema,
});
